export default __webpack_public_path__ + "static/medinice-logo-c1d0166b35d204e4bfaa0410b5b5b98e.svg";